module.exports = __webpack_public_path__ + "img/dailog1.8f183cb0.png";